module.exports = __webpack_public_path__ + "img/beauty_reshape.5c7350d.svg";